module.exports = __webpack_public_path__ + "static/media/check.e1ef0f89.svg";